//PATRICK

class CustomVariantSelector extends HTMLElement {

    constructor(){
        super();
    }

    heyListen = () => {
        this.target = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[0]}"]`);
        this.shipIt = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[1]}"]`);
        this.cashMoney = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[2]}"]`)
        if(!(this.target && this.shipIt)){
            setTimeout(() => this.heyListen(), 500);
        }
    }
    
    connectedCallback(){
        this.heyListen();
        this.addEventListener("click", () => {
            if(this.dataset.disabled !== "true"){
                this.shipIt.disabled = false;
                this.target.value = this.dataset.id;
                this.cashMoney.textContent = this.dataset.price;
                document.querySelectorAll('v-select').forEach(entry => entry.classList.remove('selected'));
                this.classList.add('selected');
            }
            else{
                this.target.value = "";
                document.querySelectorAll('v-select').forEach(entry => entry.classList.remove('selected'));
                this.cashMoney.textContent = this.dataset.price;
                this.classList.add('selected');
                this.shipIt.disabled = true;
            }
        });
    }
}

if(!window.customElements.get("v-select")){
    window.customElements.define("v-select", CustomVariantSelector);
}

class FilterOpen extends HTMLElement{
    
    constructor(){
        super();
    }

    heyListen = () => {
        this.target = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[0]}"]`);
        this.arrow = this.querySelector('span');
        if(!(this.target && this.arrow)){
            setTimeout(() => this.heyListen(), 500);
        }
        else{
            const url = new URL(document.URL);
            const params = new URLSearchParams(url.search);
            if(params.get('filter_open') === 'true'){
                this.target.classList.remove('minimized');
                this.target.classList.remove('rotated');
            }
            const f = document.querySelector(this.dataset.target);
            if(f){
                f.querySelectorAll('input, select').forEach(el => {el.addEventListener('change', () => {
                    this.target.querySelector('#is_open').value = 'true';
                    this.target.submit();
                })});
            }
            this.addEventListener("click", () => {
                this.target.classList.toggle('minimized');
                this.arrow.classList.toggle('rotated');
            });
        }
    }

    connectedCallback(){
        this.heyListen();
    }
}
if(!window.customElements.get("filter-open")){
    window.customElements.define("filter-open", FilterOpen);
}

class PatchSelector extends HTMLElement {
    constructor(){
        super();
    }

    heyListen = () => {
        this.target = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[0]}"]`);
        this.property = document.querySelector(`[data-listen-channels="${this.dataset.broadcastChannels.split(' ')[1]}"]`);
        this.selectors = this.parentElement.querySelectorAll('patch-selector');
        if(!(this.target && this.selectors)){
            setTimeout(() => {this.heyListen()});
        }
        
    }

    connectedCallback(){
        setTimeout(() => {this.heyListen()}, 500);
        this.addEventListener("click", () => {
            this.selectors.forEach(e => e.classList.remove('selected'));
            this.classList.add('selected');
            this.target.setAttribute('name', this.dataset.name);
            this.target.setAttribute('value', this.dataset.value);
            this.property.setAttribute('value', this.dataset.patchBool);
            this.property.setAttribute('name', this.dataset.patchName);
        });
    }
}
if(!window.customElements.get("patch-selector")){
    window.customElements.define("patch-selector", PatchSelector);
}


/* martina */
class CustomCollapsible extends HTMLElement {
    static CLOSED = 'minimized';
    constructor(){
        super();
    }
    open = () => {
        this.classList.remove(CustomCollapsible.CLOSED);
    }

    close = () => {
        this.classList.add(CustomCollapsible.CLOSED);
    }

    toggle = () => {
        this.classList.toggle(CustomCollapsible.CLOSED);
    }
}
if(!window.customElements.get("custom-collapsible")){
    window.customElements.define("custom-collapsible", CustomCollapsible);
}

class CollapsibleOpen extends HTMLElement {
    collapsible;
    constructor(){
        super();
    }
    connectedCallback() {
        this.addEventListener('click', () => {
            this.collapsible = document.querySelector(this.dataset.collapsible.trim());
            this.collapsible.toggle();
        });
    }
}
if(!window.customElements.get("collapsible-open")){
    window.customElements.define("collapsible-open", CollapsibleOpen);
}


//TAILOOR

class TailoorFunctions {
    
    static setCartCookie = (cvalue) => {
        cvalue = encodeURIComponent(cvalue);
        console.log("[TAILOOR] - set cart cookie: ", cvalue);

        const d = new Date();
        d.setTime(d.getTime() + (15 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = "cart=" + cvalue + ";" + expires + ";path=/";
    }
    
    static getCartCookie = () => {
        let name = "cart=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                var cvalue = c.substring(name.length, c.length)
                return decodeURIComponent(cvalue);
            }
        }
        return null;
    }

  static getGaClientId = () => {
    var cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('_ga='));
    if (!cookieValue) return null;
    var gaParts = cookieValue.split('=');
    if (gaParts.length < 2) return null;
    var gaValue = gaParts[1]; // Extract cookie value
    var clientId = gaValue.split('.').slice(2).join('.'); // Extract the Client ID
    console.log("[TAILOOR] - Cookie GA Client ID: ", clientId);
    return clientId || null;
}

    static configureGeneric = (remote_url, app_id, shop_id, model, language, origin_url) => {
        console.log("[TAILOOR] - Configure product");

        var cart_id = this.getCartCookie();
        if (cart_id == null || cart_id == undefined || cart_id == "undefined")
            cart_id = "unknown";
        var token_ga = this.getGaClientId();
        var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_generic_configure_url";

        var requestBody = {
    cart_token: cart_id,
    token_ga: token_ga,
       model_code: model,
      language: language,
      origin_url: origin_url
};
        
        fetch(request_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
        .then(response => response.json()) 
        .then(json => {
            this.setCartCookie(json.cart_token);
            window.location = json.configurator_url;
        })
        .catch(err => {
            console.log("[TAILOOR] - Error Response:");
            console.log(err);
        });
    }
    
    static configureProduct = (remote_url, app_id, shop_id, product_sku, language, origin_url) => {
        console.log("[TAILOOR] - Configure product");

        var cart_id = this.getCartCookie();
        if (cart_id == null || cart_id == undefined || cart_id == "undefined")
            cart_id = "unknown";
      
        var token_ga = this.getGaClientId();
        var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_product_configure_url";

        var requestBody = {
    cart_token: cart_id,
    token_ga: token_ga,
    product_id: product_id,
    language: language,
    origin_url: origin_url
};
        
        fetch(request_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
        .then(response => response.json()) 
        .then(json => {
            this.setCartCookie(json.cart_token);
            window.location = json.configurator_url;
        })
        .catch(err => {
            console.log("[TAILOOR] - Error Response:");
            console.log(err);
        });
    }
    
    static configureRelated = (remote_url, app_id, shop_id, product_sku, language, origin_url) => {
        console.log("[TAILOOR] - Configure product");

        var cart_id = this.getCartCookie();
        if (cart_id == null || cart_id == undefined || cart_id == "undefined")
            cart_id = "unknown";

        var token_ga = this.getGaClientId();
        var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_product_configure_url";
    
        var requestBody = {
        cart_token: cart_id,
        token_ga: token_ga,
        product_sku: product_sku,
        language: language,
        origin_url: current_url
        };
        
        fetch(request_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
        .then(response => response.json()) 
        .then(json => {
            this.setCartCookie(json.cart_token);
            window.location = json.configurator_url;
        })
        .catch(err => {
            console.log("[TAILOOR] - Error Response:");
            console.log(err);
        });
    }
}

class TailoorConfigurator extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.addEventListener('click', () => {
            TailoorFunctions.configureGeneric(this.dataset.remote_url, this.dataset.app_id, this.dataset.shop_id, this.dataset.model, this.dataset.language, this.dataset.origin_url);
        })
    }
}
if(!window.customElements.get("tailoor-configurator")){
    window.customElements.define("tailoor-configurator", TailoorConfigurator);
}

class variantButtonFixer extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const labelArr = document.querySelectorAll('label.opt-label');
        labelArr.forEach((label) => {
            if(label.previousElementSibling.tagName === 'INPUT' && label.previousElementSibling.checked){
                label.classList.add('im-blue');
                label.parentElement.querySelector(`input[id='${label.getAttribute('for')}']`).ariaChecked = true;
            }
            else if(label.previousElementSibling.tagName === 'INPUT' && !label.previousElementSibling.checked){
                label.parentElement.querySelector(`input[id='${label.getAttribute('for')}']`).ariaChecked = false;
            }
            label.addEventListener('click', () => {
                labelArr.forEach((lbl) => {
                    if(lbl.parentElement === label.parentElement)
                        lbl.classList.remove('im-blue');
                        lbl.parentElement.querySelector(`input[id='${lbl.getAttribute('for')}']`).ariaChecked = false;
                });
                label.classList.add('im-blue');
                label.parentElement.querySelector(`input[id='${label.getAttribute('for')}']`).ariaChecked = true;
                
            });
        });
    }
}
if(!window.customElements.get("variant-fixer")){
    window.customElements.define("variant-fixer", variantButtonFixer);
}

class AccessibilityManager extends HTMLElement {
    constructor(){
        super();
    }

    toggleAriaChecked = (element) => {
        element.ariaChecked = element.checked;
    }

    connectedCallback(){
        this.radio_inputs = document.querySelectorAll(`input[type='radio']`);
        this.radio_inputs.forEach((element) => {
            this.toggleAriaChecked(element);
            element.addEventListener('change', () => {
                this.toggleAriaChecked(element);
            });
        });
    }
}
if(!window.customElements.get("accessibility-manager")){
    window.customElements.define("accessibility-manager", AccessibilityManager);
}

class CollectionTabsProducts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        if (this.dataset.tabsReady === 'true') {
            return;
        }

        this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        if (!this.tabButtons.length || !this.tabPanels.length) {
            return;
        }

        this.dataset.tabsReady = 'true';

        const activeTab = this.tabButtons.find((button) => button.getAttribute('aria-selected') === 'true') || this.tabButtons[0];
        this.activateTab(activeTab);
    }

    activateTab(tabButton, moveFocus = false) {
        const targetId = tabButton.dataset.tabTarget;

        this.tabButtons.forEach((button) => {
            const isActive = button === tabButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.tabPanels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
        });

        window.requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
        });

        if (moveFocus) {
            tabButton.focus();
        }
    }
}

if(!window.customElements.get("collection-tabs-products")){
    window.customElements.define("collection-tabs-products", CollectionTabsProducts);
}

const activateCollectionTab = (root, tabButton, moveFocus = false) => {
    if (!root || !tabButton) {
        return;
    }

    if (typeof root.activateTab === 'function') {
        root.activateTab(tabButton, moveFocus);
        return;
    }

    const targetId = tabButton.dataset.tabTarget;
    const tabButtons = Array.from(root.querySelectorAll('[role="tab"]'));
    const tabPanels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    tabButtons.forEach((button) => {
        const isActive = button === tabButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabPanels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
    });

    window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
    });

    if (moveFocus) {
        tabButton.focus();
    }
};

const initCollectionTabsRoots = () => {
    document.querySelectorAll('collection-tabs-products').forEach((root) => {
        if (typeof root.init === 'function') {
            root.init();
            return;
        }

        const firstActiveTab = root.querySelector('[role="tab"][aria-selected="true"]') || root.querySelector('[role="tab"]');
        activateCollectionTab(root, firstActiveTab);
    });
};

document.addEventListener('click', (event) => {
    const button = event.target.closest('collection-tabs-products [role="tab"]');

    if (!button) {
        return;
    }

    const root = button.closest('collection-tabs-products');
    activateCollectionTab(root, button);
});

document.addEventListener('DOMContentLoaded', initCollectionTabsRoots);
document.addEventListener('shopify:section:load', initCollectionTabsRoots);
